export function formatWithDecimals(n: number, sep: string = ' '): string {
    return String(n)
        .split('')
        .flatMap((v, i, arr) => ((arr.length - i - 1) % 3 ? v : [v, sep]))
        .join('')
        .slice(0, -1);
}
